import { isUndefined } from "lodash";
import * as angular from "angular";
import * as moment from "moment";
import { playParticipants } from "play-participants";
import { playPagination } from "play-pagination";
import { playRosterPage } from "play-roster-page";
import { ngCache } from "ng-cache";
import { playOrbis } from "play-orbis";
import { playDialog } from "play-dialog";
import { ngLeague } from "ng-league/module";
// local
import { environment } from "../../environments/environment";
import * as filters from "./global/Filter";
import { playPagination as pagination } from "./pagination";
import { playPanel } from "./panel";
import { playResult } from "./result";
import { playRegion } from "./region";
import { playRanking } from "./ranking";
import { playService } from "./services";
import { playUserbox } from "./userbox";
import { playInteraction } from "./interaction";
import { IApiEndPointsProvider } from "ng-league";
import { EslIdAuthInterceptor } from "./eslid/EslIdAuthInterceptor";
import { EslIdAuthService } from "./eslid/EslIdAuthService";

export let play = angular.module("play", [
    "ngResource",
    "pascalprecht.translate",
    ngLeague.name,

    playInteraction.name,

    pagination.name,
    playPanel.name,
    playRanking.name,
    playRegion.name,
    playResult.name,
    playService.name,
    playUserbox.name,

    // npm modules
    playOrbis.name,
    playPagination.name,
    playParticipants.name,
    playRosterPage.name,
    playDialog.name,
    ngCache.name,
]);

play.filter("addSlashWhenSet", filters.addSlashWhenSet);
play.filter("timeUntil", filters.timeUntil);
play.filter("secondsAsText", filters.secondsAsText);
play.filter("formatDateTime", filters.formatDateTime);
play.filter("formatDate", filters.formatDate);
play.filter("secondsAsDate", filters.secondsAsDate);
play.filter("isEmptyPromise", filters.isEmptyPromise);
play.filter("sprintf", filters.sprintf);
play.filter("signedNumber", filters.signedNumber);
play.filter("ucfirst", filters.ucfirst);
play.filter("ceil", filters.ceil);
play.filter("abs", filters.abs);
play.filter("addUtmParams", filters.addUtmParams);
play.filter("filterSwissResult", filters.filterSwissResult);

play.service("EslIdAuthInterceptor", EslIdAuthInterceptor);
play.service("EslIdAuthService", EslIdAuthService).config([
    "$httpProvider",
    ($httpProvider: angular.IHttpProvider) => {
        $httpProvider.interceptors.push(EslIdAuthInterceptor.factory);
    },
]);

play.constant("PLAY_URL", "play.eslgaming.com");

declare var Translation: any;
play.config([
    "$locationProvider",
    "$translateProvider",
    function($locationProvider: angular.ILocationProvider, $translateProvider: any) {
        $locationProvider.hashPrefix("!");
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false,
            rewriteLinks: false,
        });
        moment.locale(Translation.language);
        $translateProvider.preferredLanguage(Translation.language);
        // use one hard-coded translation file
        $translateProvider.translations(Translation.language, Translation.data);
        // add messageformat as an optional interpolation type
        $translateProvider.useMessageFormatInterpolation();
        $translateProvider.useSanitizeValueStrategy("escaped");
    },
]);

// ngLeague
play.config([
    "ApiEndpointsProvider",
    function(ApiEndpointsProvider: IApiEndPointsProvider) {
        ApiEndpointsProvider.xapiBaseUrl = "/";
        ApiEndpointsProvider.baseUrl = `${environment.apiHost}/`;

        if (!environment.drupalProduction) {
            ApiEndpointsProvider.endpoints = {
                league: "play/v1/leagues",
                gameAccount: "play/v1/user/gameaccounts",
                match: "play/v1/matches",
                userTeam: "play/v1/user/teams",
                userPremium: "play/v1/user/premium",
                userProfileShort: "play/v1/user/short_profile",
                userProfileBasic: "play/v1/users/~/basicprofile",
                userProfileFull: "play/v1/user/profile",
                user: "play/v1/users",
                game: "play/v1/games",
                team: "play/v1/teams",
                gameAccountType: "play/v1/gameaccounts",
                gameAccountDescription: "xapi/gameaccounts",
            };
        }
    },
]);

// performance improvements
play.config([
    "$compileProvider",
    "$httpProvider",
    function($compileProvider, $httpProvider) {
        $httpProvider.useApplyAsync(true);
        $compileProvider.debugInfoEnabled(false);
    },
]);

// Add filters to rootScope so that we can pass them down to components
play.run([
    "$rootScope",
    "$filter",
    function($rootScope, $filter: angular.IFilterService) {
        $rootScope.filters = {
            date: $filter("formatDateTime"),
        };
    },
]);

angular.element(document).ready(() => {
    // angular doesn"t fire a submit when the action is undefined (element.action is always empty, even when  undefined in the HTML. So just set it to empty again)
    Array.prototype.slice.call(document.querySelectorAll("form")).forEach(function(element: HTMLFormElement) {
        if (isUndefined(element.action) || element.action === "") {
            element.action = "";
        }
    });

    // angular doesn"t reload when you are on the same page
    Array.prototype.slice.call(document.querySelectorAll("a")).forEach(function(element: HTMLFormElement) {
        if (typeof element.target === "undefined" || element.target === "") {
            element.target = "_parent";
        }
    });
});
